import React, {useContext, useEffect, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';

import {useHttpClient} from "../../../../common/hook/http";

import {ContextAuth} from '../../../../common/context/context-auth';

import Loader from '../../../../common/component/Loader/Loader';
import ComingSoon from "../../../../common/component/ComingSoon/ComingSoon";

import {Container, Row, Col} from 'react-bootstrap';

import * as IconFi from 'react-icons/fi';

import './Item.scss'

const Item = () => {
    const {callAPI} = useHttpClient();
    const location = useLocation();

    // -----------------------------------------------------------------------------------------------------------------

    const [data, setData] = useState(null)

    useEffect(() => {

        // document.querySelector('#main > .breadcrumb-wrapper').classList.remove('d-md-block')

        // با تغییر آدرس محتوای صفحه خالی می شود تا loader نمایش یابد
        if (data) setData(null)

        let pathname = location.pathname.endsWith('/') ? location.pathname.slice(0, -1) : location.pathname;

        pathname = pathname.replace('more', 'about-us')

        document.documentElement.dataset.page = pathname.split('/')[2]

        // if (pathname !== '/about-us')
        //     document.documentElement.dataset.page = 'about-us';

        const fetchData = async () => {

            const responseData = await callAPI(
                `pages/getByPath`,
                'POST',
                JSON.stringify({path: pathname})
            );

            if (responseData.message) {

            } else {

                setData({content: responseData.content, title: responseData.title, coverV: responseData.coverV, coverH: responseData.coverH})

                // document.querySelector('#main > .breadcrumb-wrapper').classList.add('d-md-block')

                // if (pathname !== '/about-us')
                //     if (responseData.title) callBreadcrumb(responseData.title)

            }

        }

        fetchData()

    }, [location.pathname])

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div id="pageMoreItem" className="mb-4 mb-xl-5">
            <Container fluid="lg" as="section">
                <Row>
                    <Col xs={12}>
                        {
                            data ? (
                                data.content ? (
                                    <div className="pt-4" dangerouslySetInnerHTML={{__html: data.content}}/>
                                ) : (
                                    <ComingSoon/>
                                )
                            ) : (
                                <div className="py-5 my-5">
                                    <Loader text="در حال دریافت اطلاعات"/>
                                </div>
                            )
                        }
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Item;